import React, { Component } from "react";

import Chat from "./Chat";

//import td from '@material-ui/core/td';
//import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import FindReplaceOutlinedIcon from '@material-ui/icons/FindReplaceOutlined';
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import OfflinePinOutlinedIcon from '@material-ui/icons/OfflinePinOutlined';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { withTranslation } from 'react-i18next';

//const styles = theme => ({
//	[theme.breakpoints.down('sm')]:{
//		bigcell: {
//			maxWidth:'150px',
//			minWidth:'50px'
//		},
//		medcell: {
//			maxWidth:'50px',
//			minWidth:'50px'
//		},
//		smallcell: {
//			maxWidth:'15px',
//			minWidth:'15px'
//		},
//	},
//	[theme.breakpoints.up('md')]:{
//		bigcell: {
//			maxWidth:'150px',
//			minWidth:'50px'
//		},
//		medcell: {
//			maxWidth:'50px',
//			minWidth:'50px'
//		},
//		smallcell: {
//			maxWidth:'50px',
//			minWidth:'50px'
//		},
//	},
//	setoverflow:{
//		overflow:'hidden',
//		display: 'block'
//	}
//});

class OrderRow extends Component {
	constructor() {
		super();
		this.state= {
			//finishing: false,
			//sendingOdoo: false
			isOpen: false,
			processing: false
		}	
//		this.handleFinish = this.handleFinish.bind(this);
		this.handleSendOdoo = this.handleSendOdoo.bind(this);
		this.handleDownloadXLIF = this.handleDownloadXLIF.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
//		this.handleUploadXLIF = this.handleUploadXLIF.bind(this);
//		this.forceFinish = this.forceFinish.bind(this);
		this.openEditor = this.openEditor.bind(this);
		this.downloadTranslation = this.downloadTranslation.bind(this);
		this.uploadTranslation = this.uploadTranslation.bind(this);
		this.downloadXlf = this.downloadXlf.bind(this);
//		this.uploadXlf = this.uploadXlf.bind(this);
		this.sendOdoo = this.sendOdoo.bind(this);
		this.deleteOrder = this.deleteOrder.bind(this);
		this.pintaLocked = this.pintaLocked.bind(this);
		this.qaOK = this.qaOK.bind(this);
		this.qaFail = this.qaFail.bind(this);
		this.handleQaOK = this.handleQaOK.bind(this);
		this.handleQaFail = this.handleQaFail.bind(this);
		this.handleQA = this.handleQA.bind(this);
		this.linkToOrderForm = this.linkToOrderForm.bind(this);
		this.nonconformityIcon = this.nonconformityIcon.bind(this);
		this.processing = this.processing.bind(this);
		this.rating = this.rating.bind(this);
		this.switchOpen = this.switchOpen.bind(this);
		this.pintaDesplegable = this.pintaDesplegable.bind(this);
	}
	
//	handleFinish(e) {
//		this.setState({finishing:true});
//		//this.props.finishActions(this.props.id, this.props.task, this.props.state);
//	}
	
	componentDidUpdate(prevProps, prevState){
		if (prevState.processing) {
			this.setState({ processing: false });
		}
	}
	
	handleSendOdoo(e){
		//this.setState({sendingOdoo: true});
		this.setState({processing: true});
		this.props.sendOdooActions(this.props.id, this.props.task, this.props.state);
	}
	
	handleDownloadXLIF(e){
		this.props.downloadXLIF(this.props.id, this.props.task, this.props.state);
	}
	
	handleDelete(e){
		this.props.deleteOrder(this.props.id);
	}
	
	handleQaOK(e){
		this.handleQA(1);
	}
	handleQaFail(e){
		this.handleQA(0);
	}
	
	handleQA(result){
		this.setState({processing: true});
		this.props.qaAction(this.props.id, this.props.task, result);
	}
	
	handleUnlock(e){
		this.props.unlockOrder(this.props.id);
	}
	
//	handleUploadXLIF(e){
//	}
	
//	forceFinish(){
//		//59413
//		if(this.props.userRole !== 'CUSTOMER'){
//			return <Tooltip title="Finish"><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}} onClick={() => { this.handleFinish(); }}>&#59424;</Icon></Tooltip>
//		}else{
//			return '';
//		}
//	}
	qaOK(){
		if(this.props.userRole !== 'CUSTOMER'){
			return <Tooltip title={this.props.t('format_qa_ok')}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}} onClick={() => { this.handleQaOK(); }}>&#59413;</Icon></Tooltip>
		}else{
			return '';
		}
	}
	
	qaFail(){
		if(this.props.userRole !== 'CUSTOMER'){
			return <Tooltip title={this.props.t('format_qa_ko')}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}} onClick={() => { this.handleQaFail(); }}>&#59393;</Icon></Tooltip>
		}else{
			return '';
		}
	}
	
	openEditor(){
		if((this.props.xlifDocumentId>0) && (this.props.userRole !== 'CUSTOMER') && (this.props.partial!="SOURCE" || (this.props.partial=="SOURCE" && (typeof this.props.qaDocument !== 'undefined') ))){
//			let editorProtocol = 'ecl-ddt:'+process.env.REACT_APP_serverURL.slice(process.env.REACT_APP_serverURL.lastIndexOf('/')+1)+'/documents-0.0.1/'+this.props.id+'/'+this.props.xlfDocument;
			let color = (this.props.state=="completed" || this.props.state=="FINISHED") ? "#99d6ff" : "#1f618d";
			return <Tooltip title={this.props.t('editor')}><Link  to={`/editor/${this.props.id}/${this.props.xlifDocumentId}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: color, cursor: "pointer"}}>&#59424;</Icon></Link></Tooltip>;
		}else{
			return '';
		}
	}
	downloadTranslation(){
		if(typeof this.props.trgDocument !== 'undefined'){
			return <Tooltip title={this.props.t('download_tr')}><a target="_blank" href={this.props.trgDocument.href+"/content?access_token="+this.props.accessToken} title={this.props.trgDocument.title}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></a></Tooltip>;
		}else{
			return '';
		}
	}
	
	downloadQA(){
		if((this.props.userRole !== 'CUSTOMER')&&(typeof this.props.qaDocument !== 'undefined')){
			return <Tooltip title={this.props.t('download_tr')}><a target="_blank" href={this.props.qaDocument.href+"/content?access_token="+this.props.accessToken} title={this.props.qaDocument.title}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></a></Tooltip>;
		}else{
			return '';
		}
	}
	
	openQA(){
		if(this.props.userRole !== 'CUSTOMER'){
			return <Tooltip title={this.props.t('open_qa')}><Link  to={`/qaList/${this.props.id}`}><OfflinePinOutlinedIcon style={{fontSize: "21px", color: "#1f618d", cursor: "pointer"}} /></Link></Tooltip>;
		}else{
			return "";
		}
	}
	
	downloadRevisionQA(){
		if(typeof this.props.revisionQaDocument !== 'undefined'){
			return <Tooltip title={this.props.t('download_tr')}><a target="_blank" href={this.props.revisionQaDocument.href+"/content?access_token="+this.props.accessToken} title={this.props.revisionQaDocument.title}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></a></Tooltip>;
		}else{
			return '';
		}
	}
	
	uploadTranslation(){
		//return <Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}} onClick={() => { this.handleFinish(); }}>&#59418;</Icon>;
		let color = (this.props.state==="completed" || this.props.state=="FINISHED") ? "#cacaca" : "#000";
		if(this.props.userRole !== 'CUSTOMER'){
			return <Tooltip title={this.props.t('upload_tr')}><Link  to={`/UploadTranslatedDocument/${this.props.id}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: color, cursor: "pointer"}}>&#59422;</Icon></Link></Tooltip>;
		}else{
			return '';
		}
	}
	
	downloadXlf(){
		if((typeof this.props.xlfDocument !== 'undefined') && (this.props.userRole !== 'CUSTOMER')){
			return <Tooltip title={this.props.t('download_xlf')}><a target="_blank" href={this.props.xlfDocument.href+"/content?access_token="+this.props.accessToken} title={this.props.xlfDocument.title}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></a></Tooltip>;
		}else{
			return '';
		}
	}
//	uploadXlf(){
//		return<Link  to={`/UploadXlf/${this.props.id}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59422;</Icon></Link>;
//	}
	
	switchOpen(){
		this.setState(prevState => ({isOpen: !prevState.isOpen}));
	}
	
	sendOdoo(sendOdooPending){
		let sendOdooT ="";
		let sendOdooC ="";
		let tooltip = "";
		let color = "#000000";
		if(this.props.userRole == "ADMIN" || this.props.userRole == "TRANSLATOR"){
			if(sendOdooPending==2 || sendOdooPending==3){
				color = "#2abac2";
				tooltip = this.props.t('send_odoo_tr');
				sendOdooC = <Tooltip title={tooltip}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: color, cursor: "pointer"}} onClick={() => { this.handleSendOdoo(); }}>&#59405;</Icon></Tooltip>;
			}
		}
		if(this.props.userRole == 'ADMIN'){
			if(sendOdooPending==1 || sendOdooPending==3){
				color = "#1e43cd";
				tooltip = this.props.t('send_odoo_cust');
				sendOdooT = <Tooltip title={tooltip}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: color, cursor: "pointer"}} onClick={() => { this.handleSendOdoo(); }}>&#59405;</Icon></Tooltip>;
			}
		}
		return <span>{sendOdooC}{sendOdooT}</span>
	}
	
	processing(){
		//return <img src={"/img/loading.gif"} alt="LOADING..." />;
		return <CircularProgress color="inherit" size={20} />;
	}
	
	deleteOrder(){
		if(this.props.userRole == 'ADMIN'){
			return <Tooltip title="Delete"><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#c0392b", cursor: "pointer"}} onClick={() => { this.handleDelete(); }}>&#59421;</Icon></Tooltip>;
		}else{
			return '';
		}
	}
	
	linkToOrderForm(){
		let color = (this.props.task=='rating') ? "#014d51":"";
		if(this.props.userRole == 'ADMIN'){
			return <span style={{ color: color}}><Link  to={`/orderForm/${this.props.id}`}>{this.props.code}</Link></span>
		}else{
			return <span style={{color: color}}>{this.props.code}</span>;
		}
	}
	
	nonconformityIcon(){
		let color="#B4B4B4";
		let title=this.props.t('open_noconf');
		
		if((typeof this.props.nonconformity !== 'undefined') && (this.props.nonconformity !== null) ){
			title=this.props.t('view_noconf');
			if((typeof this.props.nonconformity.correctionDate == 'undefined') || (this.props.nonconformity.correctionDate==null) ){
				color="#F00";
			}else{
				color="#8acf91";
			}
		}
		return <Tooltip title={title}><Link  to={`/nonconformity/${this.props.id}`} style={{textDecoration: 'none', color: color}}><ReportProblemOutlinedIcon style={{ fontSize: "16px" }}/></Link></Tooltip>;
	}
	
	rating(){
		let color = (this.props.state==="completed" || this.props.state=="FINISHED") ? "#4f6fb9" : "#000";
		return <Tooltip title={this.props.t('rating')}><Link  to={`/ratingForm/${this.props.id}`}><StarHalfIcon style={{color: color, cursor: "pointer"}} /></Link></Tooltip>;
	}
	
	pintaLocked(){
		if(this.props.userRole == 'ADMIN'){
			return <Tooltip title={this.props.t('unlk_trans')}><LockOutlinedIcon style={{ fontSize: "18px", cursor: "pointer" }} onClick={() => { this.handleUnlock(); }}/></Tooltip>;
		}else{
			return <LockOutlinedIcon style={{ fontSize: "18px" }}/>
		}
	}
	
	pintaDesplegable(){
		if(this.props.projectOrders!==null){
			return 	<React.Fragment>
					<td className="medcell d-none d-lg-table-cell">
						<IconButton
							aria-label="expand row"
								size="small"
								onClick={this.switchOpen}
							>
								{this.state.isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</IconButton>
					</td>
					
					<td className="bigcell d-none d-lg-table-cell">
						<Tooltip title={this.props.customer}><span>{this.props.customer}</span></Tooltip>
					</td>
					</React.Fragment>
		}else{
			return <td className="bigcell d-lg-table-cell" colSpan={2}><Tooltip title={this.props.customer}><span>{this.props.customer}</span></Tooltip></td>
		}
	}
	
	render() {
		const { t } = this.props;
		let accions;
		let dateF;
		let stateIcon;
		let colorEstat="#000";
		let atachment='';
		var chat;
		
		if(this.props.urgent>0){
			colorEstat="#f00";
		}
		
		if(this.props.helpDocument){
			atachment=<Tooltip title={t('atach_doc')}><span> ( <a target="_blank" style={{textDecoration: 'none'}} href={this.props.helpDocument.href+"/content?access_token="+this.props.accessToken}><Icon style={{ fontFamily: "tipoecl", fontSize: "12px", color: "#000", padding: 0, cursor: "pointer"}}>&#xe812;</Icon></a> ) </span></Tooltip>;
		}
		
		let progres="";
		switch(this.props.state){
//			case "new":
//					stateIcon = <Tooltip title="New"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat}}>&#59420;</Icon></Tooltip>;
//					progres="(0%)";
//					accions =  this.processing();//<span>{this.openEditor()}&nbsp;{this.forceFinish()}</span>;
//			break;
			case "TRANSLATION":
			case "ready":
					stateIcon = <Tooltip title={t('ready')}><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat}}>&#59425;</Icon></Tooltip>;
					accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() : <span>{this.openEditor()}&nbsp;&nbsp;&nbsp;&nbsp;{this.uploadTranslation()}&nbsp;&nbsp;&nbsp;&nbsp;{this.downloadXlf()}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}&nbsp;{this.nonconformityIcon}</span>;
					progres = "("+this.props.progres+"%)";
			break;
			case "PROOF_PRINTING":
					stateIcon = <Tooltip title={t('ready')}><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat}}>&#59425;</Icon></Tooltip>;
					accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() : <span>{this.uploadTranslation()}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}&nbsp;{this.nonconformityIcon}</span>;
					progres = "";
			break;
			case "QA":
					stateIcon = <Tooltip title={t('format_qa')}><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat}}>&#59425;</Icon></Tooltip>;
					accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() : <span>{this.openQA()}</span>;
			break;
			case "FORMAT_QA":
					stateIcon = <Tooltip title={t('format_qa')}><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat}}>&#59425;</Icon></Tooltip>;
					accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() : <span>{this.downloadQA()}&nbsp;&nbsp;&nbsp;&nbsp;{this.qaOK()}&nbsp;&nbsp;&nbsp;&nbsp;{this.qaFail()}</span>;
			break;
			case "RATING":
					stateIcon = <Tooltip title={t('ready')}><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat}}>&#59425;</Icon></Tooltip>;
					accions = <span>{this.openEditor()}&nbsp;&nbsp;&nbsp;&nbsp;{this.rating()}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}&nbsp;{this.nonconformityIcon}</span>;
					progres = "";
			break;
			case "REVISION":
					stateIcon = <Tooltip title={t('revision')}><FindInPageOutlinedIcon style={{ fontSize: "22px", color: colorEstat }}/></Tooltip>;
					if( this.props.userName==this.props.reviewer || this.props.userRole == 'ADMIN' ){
						accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() :  <span>{this.openEditor()}&nbsp;&nbsp;&nbsp;&nbsp;{this.downloadXlf()}&nbsp;&nbsp;&nbsp;&nbsp;{this.uploadTranslation()}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}&nbsp;{this.nonconformityIcon}</span>;
					}else{
						accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() :  <span>{this.downloadTranslation()}</span>;
					}
			break;
			case "REVISION_FORMAT_QA":
					stateIcon = <Tooltip title={t('revision_format_qa')}><FindInPageOutlinedIcon style={{ fontSize: "22px", color: colorEstat }}/></Tooltip>;
					if( this.props.userName==this.props.reviewer || this.props.userRole == 'ADMIN' ){
						accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() : <span>{this.downloadRevisionQA()}&nbsp;&nbsp;&nbsp;&nbsp;{this.qaOK()}&nbsp;&nbsp;&nbsp;&nbsp;{this.qaFail()}</span>;
					}else{
						accions = (this.props.lock>0 && (this.props.userRole !== 'CUSTOMER')) ? this.pintaLocked() : <span>{this.downloadTranslation()}</span>;
					}
			break;
			case "FINISHED":
			case "completed":
				if(!this.props.urgent>0){
					colorEstat="#00b800";
				}
				stateIcon = <Tooltip title={t('completed')}><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat }}>&#59427;</Icon></Tooltip>;
				dateF = <Tooltip title={new Intl.DateTimeFormat('es-ES', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric',  minute: 'numeric', hour12: false}).format(new Date(this.props.finished))}><span>{new Intl.DateTimeFormat('es-ES', {year: '2-digit', month: 'numeric', day: 'numeric'}).format(new Date(this.props.finished))}</span></Tooltip>;
				let sendOdooPending = 0;
				if(this.props.sendOdooC==0) sendOdooPending+=1;
				if(this.props.sendOdooT==0) sendOdooPending+=2;
				if(sendOdooPending>0){
					if(this.props.task=='rating'){
						accions = <span>{this.openEditor()}&nbsp;&nbsp;&nbsp;&nbsp;{this.rating()}&nbsp;&nbsp;&nbsp;&nbsp;{this.sendOdoo(sendOdooPending)}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}</span>;
					}else{
						accions = <span>{this.openEditor()}&nbsp;&nbsp;&nbsp;&nbsp;{this.uploadTranslation()}&nbsp;&nbsp;&nbsp;&nbsp;{this.downloadTranslation()}&nbsp;&nbsp;&nbsp;&nbsp;{this.sendOdoo(sendOdooPending)}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}</span>;
					}
				}else{
					if(this.props.task=='rating'){
						accions = <span>{this.openEditor()}&nbsp;&nbsp;&nbsp;&nbsp;{this.rating()}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}</span>;
					}else{
						accions = <span>{this.openEditor()}&nbsp;&nbsp;&nbsp;&nbsp;{this.uploadTranslation()}&nbsp;&nbsp;&nbsp;&nbsp;{this.downloadTranslation()}&nbsp;&nbsp;&nbsp;&nbsp;{this.deleteOrder()}</span>;
					}
				}
			break;
			default:
				accions = <span>{this.deleteOrder()}</span>;
				
		}
		
		if(this.state.processing){
			accions = this.processing();
		}
		
		var revisor="";
		if(this.props.reviewer.length>0){
			revisor=this.props.reviewer;
		}else if((this.props.responsable !="") && (this.props.state=="completed"  || this.props.state=="FINISHED")){
			revisor="ECL";
		}
		const rowClass = this.props.inProject>0 ? "projectOrderRow" : ((this.props.state==="FINISHED" && this.props.userRole !== 'CUSTOMER' && this.props.partial!=="SOURCE") ? "finishedOrderRow":((this.props.partial=="SOURCE" && this.props.userRole !== 'CUSTOMER') ? "splitsource" : ""));
		
		//<span className={this.props.classes.setoverflow}>
		return (
			<React.Fragment>
			<tr key={this.props.id} className={rowClass}>
			{this.pintaDesplegable()}
			<td><Tooltip title={this.props.code}>{this.linkToOrderForm()}</Tooltip></td>
			<td className="smallcell">
				<Chat
					orderId={this.props.id}
					messages={this.props.messages}
					sendMessage={this.props.sendMessage}
					tooltip=""
				/>
			</td>
			<td className="bigcell"><span>{atachment}<Tooltip title={this.props.description}><a target="_blank" href={this.props.orgDoc.href+"/content?access_token="+this.props.accessToken} title={this.props.orgDoc.title}>{this.props.description}</a></Tooltip></span></td>
			<td>{this.props.langPair} {this.props.task=="proof_print" && <span style={{fontFamily: "'Times New Roman', Times, serif", fontSize: "18px", fontWeight: "bold", color: "#3b9646"}}> G </span>}</td>
			<td className="smallcell">{this.nonconformityIcon()} {stateIcon} {progres}</td>
			{this.props.viewTranslators &&  <td className="medcell d-lg-table-cell"><Tooltip title={this.props.responsable}><span>{this.props.responsable}</span></Tooltip></td>}
			{this.props.viewTranslators && (this.props.userRole!="TRANSLATOR") && <td className="medcell d-none d-lg-table-cell"><Tooltip title={revisor}><span>{revisor}</span></Tooltip></td>}
			<td>{this.props.words}</td>
			<td className="d-lg-table-cell"><Tooltip title={new Intl.DateTimeFormat('es-ES', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric',  minute: 'numeric', hour12: false}).format(new Date(this.props.recvd))}><span>{new Intl.DateTimeFormat('es-ES', {year: '2-digit', month: 'numeric', day: 'numeric'}).format(new Date(this.props.recvd))}</span></Tooltip></td>
			<td className="d-none d-lg-table-cell">{dateF}</td>
			<td>{accions}</td>
			</tr>
			{this.state.isOpen ? this.props.projectOrders : ""}
			</React.Fragment>
		);
	}
}
//<td><IconButton style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000"}}>&#59397;</IconButton></td>
function EditIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M2 12.88V16h3.12L14 7.12 10.88 4 2 12.88zm14.76-8.51c.33-.33.33-.85 0-1.18l-1.95-1.95c-.33-.33-.85-.33-1.18 0L12 2.88 15.12 6l1.64-1.63z" />
    </SvgIcon>
  );
}

export default withTranslation()(OrderRow);